import { registerValidator } from 'core/forms';

function isBetweenMinMax({ fieldValue, schema }) {
  const { minValue, maxValue } = schema;

  const error = `This field should have a value between ${minValue} and ${maxValue}`;

  const isValueBetweenMinMax = fieldValue >= minValue && fieldValue <= maxValue;

  const isValueANumber = Number(fieldValue);

  if ((isValueANumber && !isValueBetweenMinMax)) {
    return {
      hasError: true,
      error,
    };
  }

  return {
    hasError: false,
  };
}

registerValidator('isBetweenMinMax', isBetweenMinMax);

export default isBetweenMinMax;
